import {
  Text,
  GreyGrey90,
  Image,
  ListItem,
  Primary13Regular,
  UnorderedList,
  Box,
  Flex
} from '@sequencehq/core-components'
import coverImage from './zapierCover.png'

export const ZapierIntegrationDetail = () => {
  return (
    <Flex flexDirection="column" gap="20px">
      <Image
        src={coverImage}
        width="100%"
        borderRadius="8px"
        draggable={false}
      />
      <Text {...Primary13Regular} color={GreyGrey90}>
        Seamlessly connect Sequencehq.com with Zapier to automate notifications
        and workflows for key events. Keep your team informed and in control by
        triggering real-time updates when:
      </Text>
      <Box {...Primary13Regular} color={GreyGrey90} lineHeight="18px">
        <UnorderedList>
          <ListItem>
            Quotes are (re)published or signed by all recipients
          </ListItem>
          <ListItem>
            Company or bank details are updated so no accidents slip through
          </ListItem>
          <ListItem>New customers are added</ListItem>
          <ListItem>Billing schedules are completed</ListItem>
        </UnorderedList>
      </Box>
    </Flex>
  )
}
